// src/components/Toast.js
import React, { useState, useEffect } from 'react';

function ToastMessage({ message, duration = 3000, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="toast">
      {message}
    </div>
  );
}

export default ToastMessage;